import { useNavigate, useParams } from 'react-router-dom'
import { signOut } from 'firebase/auth'

import { getDocument, getSubDocumentsWithQuery } from '../../../firebase/firestore'
import { logIn } from '../../../firebase/auth'
import { useGlobalContext } from '../../../context/ContextGlobal'
// import { TryCatch } from '../../../utils/general'
import { Path } from '../../../router/paths'
import { TimestampNow } from '../../../utils/dates'
import { auth } from '../../../firebase'
// import { Path } from '../../../router/paths'

// const { useGlobalContext } = require("../../../context/ContextGlobal")

const useCollaborator = (authenticar = false) => {
  const { user, setUser, setAlerts, loading, setLoading } = useGlobalContext()

  const { token } = useParams()

  const navigate = useNavigate()

  const getAutentications = async () => {
    const get = await getDocument('_authentications', token)
    // console.log(get)
    const getAutentication = await logIn(get.email, get.pw)

    if (getAutentication?.error) {
      setAlerts((prev) => [
        ...prev,
        {
          type: 'error',
          msg: getAutentication?.error,
          title: 'Erro na autenticação',
        },
      ])
      return navigate(Path.CollabLogin)
    }

    return getAutentication.success
  }

  const logout = async () => {
    try {
      await signOut(auth)
      // console.log('Desconectado com sucesso.')
    } catch (error) {
      console.error('Erro ao sair:', error)
    }
  }

  const getInfosCollaborator = async (newUser) => {
    const getUser = await getDocument('colaboradores', newUser.uid)
    const getPlans = await getSubDocumentsWithQuery('colaboradores', newUser.uid, 'plans', 'status', '==', 'active')

    const planActive = getPlans
      .sort((a, b) => {
        if (a.dtEndPlan === undefined) return 1
        if (b.dtEndPlan === undefined) return -1
        return a.dtEndPlan - b.dtEndPlan
      })
      .find((item) => (item.dtEndPlan ?? Infinity) >= TimestampNow())

    if (planActive) {
      try {
        const getPlan = await getDocument('plans', planActive.idPlan)

        newUser = {
          ...getUser,
          plans: { ...getPlan, ...planActive },
          allPlans: getPlans,
        }
        return setUser(newUser)
      } catch (e) {
        console.error(e.message)
      }
    }

    return setUser(getUser)
  }

  const Authentication = async () => {
    try {
      await setUser({})
      await logout()
      const newUser = await getAutentications()
      await getInfosCollaborator(newUser)
    } catch (e) {
      console.log(e.message)
      navigate(Path.CollabLogin)
    }
  }

  // useEffect(() => {
  //   Authentication()
  // }, [])

  return { user, setUser, token, setAlerts, loading, setLoading, Authentication }
}

export default useCollaborator
